import { Injectable } from '@angular/core';
import { FieldType } from 'angular-slickgrid';
import { gridconfig, masterGridConfig } from '../app-enum.enum';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  reportFilterConfig = {
    'showSideBar': false,
    'showReset': true
  };

  constructor() { }

  //Grid
  getReportTableColumnConfigs() {
    return [
      {
        id: 'id',
        name: 'Seq No',
        field: 'id',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        formatter: function (row) { return (row + 1); },
        minWidth: 40
      },
      {
        id: 'SOURCE',
        name: 'Request Source',
        field: 'SOURCE',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 70
      },
      {
        id: 'REQUEST_NUMBER',
        name: 'Request No',
        field: 'REQUEST_NUMBER',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        formatter: (row, cell, value, columnDef, dataContext) => {
          return '<a class="cursor-pointer" id="REQUEST_NUMBER">' + value + '</a>';
        },
        minWidth: 70
      },
      {
        id: 'CREATED_BY',
        name: 'Created By',
        field: 'CREATED_BY',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 100
      },
      {
        id: 'REQUEST_DATE',
        name: 'Requested Time',
        field: 'REQUEST_DATE',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 120
      },
      {
        id: 'REQUESTED_PICK_DATETIME',
        name: 'Requested Pick DateTime',
        field: 'REQUESTED_PICK_DATETIME',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 120
      },
      {
        id: 'REQ_STATUS',
        name: 'Request Status',
        field: 'REQ_STATUS',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 120
      },
      {
        id: 'REFERENCE_DOC_NO',
        name: 'Reference Doc no.',
        field: 'REFERENCE_DOC_NO',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 100
      },
      {
        id: 'PRIME_VEHICLE_ID',
        name: 'Prime Mover',
        field: 'PRIME_VEHICLE_ID',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 100
      },
      {
        id: 'TRUCK_VEHICLE_ID',
        name: 'Rigid/Trailer ID',
        field: 'TRUCK_VEHICLE_ID',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 100
      },
      {
        id: 'PURPOSE_OF_TRIP',
        name: 'Purpose of Trip',
        field: 'PURPOSE_OF_TRIP',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 120
      },
      {
        id: 'FROM_LOC',
        name: 'From Location',
        field: 'FROM_LOC',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 120
      },
      {
        id: 'VIA_LOC',
        name: 'Via Location',
        field: 'VIA_LOC',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 120
      },
      {
        id: 'TO_LOC',
        name: 'To Location',
        field: 'TO_LOC',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 120
      },
      {
        id: 'PLAN_NO',
        name: 'Plan No',
        field: 'PLAN_NO',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        formatter: (row, cell, value, columnDef, dataContext) => {
          return '<a class="cursor-pointer" id="PLAN_NO">' + value + '</a>';
        },
        minWidth: 70
      },
      {
        id: 'PLAN_DATE',
        name: 'Plan Date',
        field: 'PLAN_DATE',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 80
      },
      {
        id: 'VEH_ALLOCATION_TIME',
        name: 'Vehicle Allocation Time',
        field: 'VEH_ALLOCATION_TIME',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 80
      },
      {
        id: 'PLANNED_BY',
        name: 'Planned By',
        field: 'PLANNED_BY',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 100
      },
      {
        id: 'PLAN_STATUS',
        name: 'Plan Status',
        field: 'PLAN_STATUS',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 90
      },
      {
        id: 'PAX',
        name: 'Passenger count',
        field: 'PAX',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 70
      },
      {
        id: 'DRIVER_NAME',
        name: 'Driver name',
        field: 'DRIVER_NAME',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 100
      },
      {
        id: 'DRIVER_CONT_NO',
        name: 'Driver contact no.',
        field: 'DRIVER_CONT_NO',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 100
      },
      {
        id: 'TYPE',
        name: 'Type',
        field: 'TYPE',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 80
      },
      {
        id: 'VEHICLE_INSPECTION_NO',
        name: 'Vehicle Inspection no.',
        field: 'VEHICLE_INSPECTION_NO',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 100
      },
      {
        id: 'INSP_STATUS',
        name: 'Inspection Status',
        field: 'INSP_STATUS',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 100
      },
      {
        id: 'INSP_DATE',
        name: 'Inspection Date',
        field: 'INSP_DATE',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 100
      },
      {
        id: 'TRIP_NO',
        name: 'Trip No.',
        field: 'TRIP_NO',
        sortable: true,
        formatter: (row, cell, value, columnDef, dataContext) => {
          return '<a class="cursor-pointer" id="TRIP_NO">' + value + '</a>';
        },
        columnGroup: 'REPORT DETAILS',
        minWidth: 80
      },
      {
        id: 'TRIP_DATE',
        name: 'Trip Date',
        field: 'TRIP_DATE',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 80
      },
      {
        id: 'TRIP_STATUS',
        name: 'Trip Status',
        field: 'TRIP_STATUS',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 80
      },
      {
        id: 'REASON_CODE',
        name: 'Reason Code',
        field: 'REASON_CODE',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 100
      },
      {
        id: 'JOURNEY_PLAN_NO',
        name: 'Journey Plan no.',
        field: 'JOURNEY_PLAN_NO',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 100
      },
      {
        id: 'JOURNEY_PLANNER_NAME',
        name: 'Journey Manager name',
        field: 'JOURNEY_PLANNER_NAME',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 120
      },
      {
        id: 'JOURNEY_DATE',
        name: 'Journey Date',
        field: 'JOURNEY_DATE',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 100
      },
      {
        id: 'START_STOP',
        name: 'JP Start Stop',
        field: 'START_STOP',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 120
      },
      {
        id: 'JOURNEY_STATUS',
        name: 'Journey Status',
        field: 'JOURNEY_STATUS',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 100
      },
      {
        id: 'SCORE_CARD',
        name: 'Production Incentive',
        field: 'SCORE_CARD',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 100
      },
      {
        id: 'JP_DURATION',
        name: 'JP duration',
        field: 'JP_DURATION',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 70
      },
      {
        id: 'START_WITHIN_FENCE',
        name: 'Start within the fence',
        field: 'START_WITHIN_FENCE',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 100
      },
      {
        id: 'END_WITHIN_FENCE',
        name: 'End within the fence',
        field: 'END_WITHIN_FENCE',
        sortable: true,
        columnGroup: 'REPORT DETAILS',
        minWidth: 100
      }, {
        id: 'JP_REL_TIME',
        name: 'Journey Release Time',
        field: 'JP_REL_TIME',
        sortable: true,
        type: FieldType.string,
        minWidth: 130,
        cssClass: 'text-align-right'
      }, {
        id: 'JP_REL_FLAG',
        name: 'Journey Release Flag',
        field: 'JP_REL_FLAG',
        sortable: true,
        type: FieldType.string,
        minWidth: 130
      }, {
        id: 'ALLOCATED_FLAG',
        name: 'Allocated Flag',
        field: 'ALLOCATED_FLAG',
        sortable: true,
        type: FieldType.string,
        minWidth: 130
      }, {
        id: 'COMP_TYPE',
        name: 'Complaince Type',
        field: 'COMP_TYPE',
        sortable: true,
        type: FieldType.string,
        minWidth: 130
      }];
  }

  //Modal Grid for Request
  getReqTableColumnConfigs() {
    return [
      {
        id: 'id',
        name: 'Seq No',
        field: 'id',
        sortable: true,
        formatter: function (row) { return (row + 1); },
        minWidth: 40
      },
      {
        id: 'REQUEST_NO',
        name: 'Request Number',
        field: 'REQUEST_NO',
        sortable: true,
        minWidth: 70
      },
      {
        id: 'ORIGIN',
        name: 'Origin',
        field: 'ORIGIN',
        sortable: true,
        minWidth: 100
      },
      {
        id: 'DESTINATION',
        name: 'Destination',
        field: 'DESTINATION',
        sortable: true,
        minWidth: 100
      },
      {
        id: 'PAYLOAD_TYPE',
        name: 'Payload type',
        field: 'PAYLOAD_TYPE',
        sortable: true,
        minWidth: 120
      },
      {
        id: 'DESCRIPTION',
        name: 'Description',
        field: 'DESCRIPTION',
        sortable: true,
        minWidth: 80
      },
      {
        id: 'WEIGHT',
        name: 'Weight',
        field: 'WEIGHT',
        sortable: true,
        minWidth: 120
      },
      {
        id: 'VOLUME',
        name: 'Volume',
        field: 'VOLUME',
        sortable: true,
        minWidth: 100
      },
      {
        id: 'QUANTITY',
        name: 'Quantity',
        field: 'QUANTITY',
        sortable: true,
        minWidth: 100
      },
      {
        id: 'UOM',
        name: 'UOM',
        field: 'UOM',
        sortable: true,
        minWidth: 70
      }];
  }

  //Modal Grid for Trip-Material
  getTripMatTableColumnConfigs() {
    return [
      {
        id: 'id',
        name: 'Seq No',
        field: 'id',
        sortable: true,
        columnGroup: 'Trip Material Details',
        formatter: function (row) { return (row + 1); },
        minWidth: 40
      },
      {
        id: 'ITEM_DESCRIPTION',
        name: 'Item Description/ Name',
        field: 'ITEM_DESCRIPTION',
        sortable: true,
        columnGroup: 'Trip Material Details',
        minWidth: 130
      },
      {
        id: 'PLAN_QTY',
        name: 'Plan Qty.',
        field: 'PLAN_QTY',
        sortable: true,
        columnGroup: 'Trip Material Details',
        minWidth: 100
      },
      {
        id: 'PAYLOAD_TYPE',
        name: 'Payload Type',
        field: 'PAYLOAD_TYPE',
        sortable: true,
        columnGroup: 'Trip Material Details',
        minWidth: 130
      },
      {
        id: 'LOAD_QTY',
        name: 'Loading Qty.',
        field: 'LOAD_QTY',
        sortable: true,
        columnGroup: 'Trip Material Details',
        minWidth: 100
      },
      {
        id: 'UNLOAD_QTY',
        name: 'Unloading Qty.',
        field: 'UNLOAD_QTY',
        sortable: true,
        columnGroup: 'Trip Material Details',
        minWidth: 120
      },
      {
        id: 'LOADING_LOCATION',
        name: 'Loading location',
        field: 'LOADING_LOCATION',
        sortable: true,
        columnGroup: 'Trip Material Details',
        minWidth: 120
      },
      {
        id: 'UNLOADING_LOCATION',
        name: 'Unloading location',
        field: 'UNLOADING_LOCATION',
        sortable: true,
        columnGroup: 'Trip Material Details',
        minWidth: 80
      },
      {
        id: 'LOAD_INSPECTION_NO',
        name: 'Loading Inspection no.',
        field: 'LOAD_INSPECTION_NO',
        sortable: true,
        columnGroup: 'Trip Material Details',
        minWidth: 100
      },
      {
        id: 'INSP_STATUS',
        name: 'Inspection Status',
        field: 'INSP_STATUS',
        sortable: true,
        columnGroup: 'Trip Material Details',
        minWidth: 100
      },
      {
        id: 'LOCATION_CONTACT',
        name: 'Location contact',
        field: 'LOCATION_CONTACT',
        sortable: true,
        columnGroup: 'Trip Material Details',
        minWidth: 120
      },
      {
        id: 'LOADING_STATUS',
        name: 'Loading Status',
        field: 'LOADING_STATUS',
        sortable: true,
        columnGroup: 'Trip Material Details',
        minWidth: 100
      },
      {
        id: 'UNLOADING_STATUS',
        name: 'Unloading Status',
        field: 'UNLOADING_STATUS',
        sortable: true,
        columnGroup: 'Trip Material Details',
        minWidth: 100
      },
      {
        id: 'REQ_PICK_DT_TM',
        name: 'Req Pick datetime',
        field: 'REQ_PICK_DT_TM',
        sortable: true,
        columnGroup: 'Trip Material Details',
        minWidth: 70
      },
      {
        id: 'REQ_DROP_DT_TM',
        name: 'Req Drop datetime',
        field: 'REQ_DROP_DT_TM',
        sortable: true,
        columnGroup: 'Trip Material Details',
        minWidth: 70
      },
      {
        id: 'REQUEST_NO',
        name: 'Request No.',
        field: 'REQUEST_NO',
        sortable: true,
        columnGroup: 'Trip Material Details',
        minWidth: 70
      }];
  }

  //Modal Grid for Trip-Pax
  getTripPaxTableColumnConfigs() {
    return [
      {
        id: 'id',
        name: 'Seq No',
        field: 'id',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        formatter: function (row) { return (row + 1); },
        minWidth: 40
      },
      {
        id: 'PICK_LOCATION',
        name: 'Pick Location',
        field: 'PICK_LOCATION',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 70
      },
      {
        id: 'DROP_LOCATION',
        name: 'Drop location',
        field: 'DROP_LOCATION',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 100
      },
      {
        id: 'PASSENGER_NAME',
        name: 'Passenger ID - Name',
        field: 'PASSENGER_NAME',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 100
      },
      {
        id: 'PASSENGER_CONTACT',
        name: 'Passenger contact',
        field: 'PASSENGER_CONTACT',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 120
      },
      {
        id: 'PLANNED_PICK_TIME',
        name: 'Planned pick datetime',
        field: 'PLANNED_PICK_TIME',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 120
      },
      {
        id: 'PLANNED_DROP_TIME',
        name: 'Planned drop datetime',
        field: 'PLANNED_DROP_TIME',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 100
      },
      {
        id: 'ACTUAL_PICK_TIME',
        name: 'Actual Pick up datetime',
        field: 'ACTUAL_PICK_TIME',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 120
      },
      {
        id: 'ACTUAL_DROP_TIME',
        name: 'Actual Drop datetime',
        field: 'ACTUAL_DROP_TIME',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 100
      },
      {
        id: 'REQ_PICK_DT_TM',
        name: 'Req Pick datetime',
        field: 'REQ_PICK_DT_TM',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 70
      },
      {
        id: 'REQ_DROP_DT_TM',
        name: 'Req Drop datetime',
        field: 'REQ_DROP_DT_TM',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 70
      },
      {
        id: 'REQUEST_NO',
        name: 'Request No.',
        field: 'REQUEST_NO',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 100
      }];
  }

  //config
  getReportTableConfigs() {
    return {
      gridId: 'reportListTable',
      idField: 'id',
      containerHeight: '98vh',
      canExportAsExcel: true,
      selectionMode: 'multiple',
      exportFileName: 'Report List',
      dateFormat: 'DD/MM/YYYY',
      canAddRowManually: false,
      canDeleteRowManually: false,
      showFilter: true,
      showAdvanceFilter: true,
      canCopyRows: false,
      showColumnFilter: false,
      emptyObject: {},
      enableAutoResize: true,       // true by default
      enableCellNavigation: true,
      enableCheckboxSelector: false,
      enableRowSelection: true,
      editable: true,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: true
      },
      autoResize: {
        maxHeight: gridconfig.gridHeightWithoutHeader,
      },
      createPreHeaderPanel: true,
      showPreHeaderPanel: false,
      enablePagination: false,
      enableGrouping: false,
      autoEdit: true,
      alwaysShowVerticalScroll: true,
      forceFitColumns: false
    };
  }

  //search
  getReportFilterTemplate() {
    return [{
      'id': 'strReqNo',
      'labelName': 'Request No',
      'type': 'input',
      'validations': [],
      'isReadOnly': false,
      'isVisible': true,
      'position': 1,
      'class': 'col-md-6'
    }, {
      'id': 'dtReqFromDate',
      'labelName': 'Request From Date',
      'type': 'picker',
      'placeholder': 'DD/MM/YYYY',
      'isVisible': true,
      'pickerType': 'calendar',
      'dateFormat': 'DD/MM/YYYY',
      'maxDate': '',
      'minDate': '',
      'invalidDates': [],
      'disabledDays': [],
      'noOfMonths': 1,
      'validations': [],
      'position': 2,
      'class': 'col-md-6'
    }, {
      'id': 'dtReqToDate',
      'labelName': 'Request To Date',
      'type': 'picker',
      'placeholder': 'DD/MM/YYYY',
      'isVisible': true,
      'pickerType': 'calendar',
      'dateFormat': 'DD/MM/YYYY',
      'maxDate': '',
      'minDate': '',
      'invalidDates': [],
      'disabledDays': [],
      'noOfMonths': 1,
      'validations': [],
      'position': 2,
      'class': 'col-md-6'
    }, {
      'id': 'strTruckRegNo',
      'labelName': 'Vehicle Regn. no',
      'type': 'input',
      'validations': [],
      'isReadOnly': false,
      'isVisible': true,
      'position': 1,
      'class': 'col-md-6'
    }, {
      'id': 'strPlanNo',
      'labelName': 'Plan no',
      'type': 'input',
      'validations': [],
      'isReadOnly': false,
      'isVisible': true,
      'position': 1,
      'class': 'col-md-6'
    }, {
      'id': 'dtPlanFromDate',
      'labelName': 'Plan From Date',
      'type': 'picker',
      'placeholder': 'DD/MM/YYYY',
      'isVisible': true,
      'pickerType': 'calendar',
      'dateFormat': 'DD/MM/YYYY',
      'maxDate': '',
      'minDate': '',
      'invalidDates': [],
      'disabledDays': [],
      'noOfMonths': 1,
      'validations': [],
      'position': 2,
      'class': 'col-md-6'
    }, {
      'id': 'dtPlanToDate',
      'labelName': 'Plan To Date',
      'type': 'picker',
      'placeholder': 'DD/MM/YYYY',
      'isVisible': true,
      'pickerType': 'calendar',
      'dateFormat': 'DD/MM/YYYY',
      'maxDate': '',
      'minDate': '',
      'invalidDates': [],
      'disabledDays': [],
      'noOfMonths': 1,
      'validations': [],
      'position': 2,
      'class': 'col-md-6'
    }, {
      'id': 'strPurposeTrip',
      'labelName': 'Purpose of Trip',
      'type': 'search',
      'placeholder': 'Select Purpose',
      'minlength': 1,
      'isVisible': true,
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': 'id',
      'defaultValue': {
        'value': 'ALL',
        'id': 'ALL'
      },
      'datasource': [],
      'validations': [],
      'position': 1,
      'class': 'col-md-6'
    }, {
      'id': 'strVehicleInspNo',
      'labelName': 'Vehicle Inspection no.',
      'type': 'input',
      'validations': [],
      'isReadOnly': false,
      'isVisible': true,
      'position': 1,
      'class': 'col-md-6'
    }, {
      'id': 'strLoadInspNo',
      'labelName': 'Load Inspection no.',
      'type': 'input',
      'validations': [],
      'isReadOnly': false,
      'isVisible': true,
      'position': 1,
      'class': 'col-md-6'
    }, {
      'id': 'dtJourFromDate',
      'labelName': 'Journey From Date',
      'type': 'picker',
      'placeholder': 'DD/MM/YYYY',
      'isVisible': true,
      'pickerType': 'calendar',
      'dateFormat': 'DD/MM/YYYY',
      'maxDate': '',
      'minDate': '',
      'invalidDates': [],
      'disabledDays': [],
      'noOfMonths': 1,
      'validations': [],
      'position': 2,
      'class': 'col-md-6'
    }, {
      'id': 'dtJournToDate',
      'labelName': 'Journey To Date',
      'type': 'picker',
      'placeholder': 'DD/MM/YYYY',
      'isVisible': true,
      'pickerType': 'calendar',
      'dateFormat': 'DD/MM/YYYY',
      'maxDate': '',
      'minDate': '',
      'invalidDates': [],
      'disabledDays': [],
      'noOfMonths': 1,
      'validations': [],
      'position': 2,
      'class': 'col-md-6'
    }, {
      'id': 'strType',
      'labelName': 'Type',
      'type': 'search',
      'placeholder': 'Select Type',
      'minlength': 1,
      'isVisible': true,
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': 'id',
      'defaultValue': {
        'value': 'ALL',
        'id': 'ALL'
      },
      'datasource': [],
      'validations': [],
      'position': 1,
      'class': 'col-md-6'
    }, {
      'id': 'strDriverId',
      'labelName': 'Driver ID',
      'type': 'input',
      'validations': [],
      'isReadOnly': false,
      'isVisible': true,
      'position': 1,
      'class': 'col-md-6'
    }, {
      'id': 'strDriverName',
      'labelName': 'Driver Name',
      'type': 'input',
      'validations': [],
      'isReadOnly': false,
      'isVisible': true,
      'position': 1,
      'class': 'col-md-6'
    }, {
      'id': 'strRefDocNo',
      'labelName': 'Ref Doc No.',
      'type': 'input',
      'validations': [],
      'isReadOnly': false,
      'isVisible': true,
      'position': 1,
      'class': 'col-md-6'
    }, {
      'id': 'strCreatedBy',
      'labelName': 'Created By',
      'type': 'input',
      'validations': [],
      'isReadOnly': false,
      'isVisible': true,
      'position': 1,
      'class': 'col-md-6'
    }, {
      'id': 'strSource',
      'labelName': 'Request source',
      'type': 'search',
      'placeholder': 'Select Status',
      'minlength': 1,
      'isVisible': true,
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': 'id',
      'defaultValue': {
        'value': 'ALL',
        'id': 'ALL'
      },
      'datasource': [],
      'validations': [],
      'position': 1,
      'class': 'col-md-6'
    }, {
      'id': 'strPlanStatus',
      'labelName': 'Plan status',
      'type': 'multiselect',
      'placeholder': 'Select Status',
      'minlength': 1,
      'isVisible': true,
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': 'id',
      'optionLabel': 'value',
      'selector': ',',
      'seperator': ',',
      'class': 'col-md-12',
      'labelClass': 'col-md-3',
      'elemClass': 'col-md-9',
      'datasource': '',
      'validations': [],
      'position': 1
    }, {
      'id': 'strJourneyStatus',
      'labelName': 'Journey status',
      'type': 'multiselect',
      'placeholder': 'Select Status',
      'minlength': 1,
      'isVisible': true,
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': 'id',
      'optionLabel': 'value',
      'selector': ',',
      'seperator': ',',
      'class': 'col-md-12',
      'labelClass': 'col-md-3',
      'elemClass': 'col-md-9',
      'datasource': '',
      'validations': [],
      'position': 1
    }, {
      'id': 'strStatus',
      'labelName': 'Request status',
      'type': 'multiselect',
      'placeholder': 'Select Status',
      'minlength': 1,
      'isVisible': true,
      'optionLabel': 'value',
      'selector': ',',
      'seperator': ',',
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': 'id',
      'class': 'col-md-12',
      'labelClass': 'col-md-3',
      'elemClass': 'col-md-9',
      'datasource': '',
      'validations': [],
      'position': 1
    }, {
      'id': 'searchButton',
      'buttonName': 'Search',
      'onClickEvent': '',
      'onChangeEvent': '',
      'isVisible': true,
      'type': 'button',
      'isSearchBtn': true
    }];
  }
}


